import { brochureLocal } from './brochureLanding/brochureLocal';
import { brochureStructure } from './brochureLanding/brochureStructure';

function themeController() {
  brochureLocal();
  brochureStructure();
}

export { themeController };
